import { defineMessages } from "react-intl";

const AudienceMessages = defineMessages({
  acceptCurrency: {
    defaultMessage:
      "MediaMath accepts currency in the form of XXXX.XX, where cents are separated by a period (.). The following formats are not accepted: X,XXX.XX, XXXX,XX, X XXX.XX, or X XXX,XX.",
    id: "audience.pixels.event.acceptCurrency",
  },
  activate: {
    defaultMessage: "Activate",
    id: "audience.pixels.list.actions.activate",
  },
  active: {
    defaultMessage: "Active",
    id: "audience.status.active",
  },
  adaptive: {
    defaultMessage: "Adaptive",
    id: "audience.segments.list.column.adaptive",
  },
  adaptiveSegment: {
    defaultMessage: "Adaptive Segment",
    id: "audience.segments.list.btn.adaptiveSegment",
  },
  adaptiveSegmentName: {
    defaultMessage: "Adaptive Segment Name",
    id: "audience.segments.segment.form.adaptiveSegmentName",
  },
  addAttr: {
    defaultMessage: "+ Add Attribute",
    id: "audience.pixels.event.addAttr",
  },
  addBehavior: {
    defaultMessage: "Add Behavior",
    id: "audience.segments.addBehavior",
  },
  addBehaviorToolTip: {
    defaultMessage: "Select Advertiser to activate this button",
    id: "audience.segments.addBehaviorToolTip",
  },
  addEventFilter: {
    defaultMessage: "Add Event Filter",
    id: "audience.segments.standard.addEventFilter",
  },
  addPixel: {
    defaultMessage: "+ Add Pixel",
    id: "audience.pixels.event.addPixel",
  },
  addToContainer: {
    defaultMessage: "Add Pixels to Container (optional)",
    id: "audience.pixels.event.addToContainer",
  },
  addUrl: {
    defaultMessage: "+ Add URL",
    id: "audience.pixels.event.addUrl",
  },
  advancedTools: {
    defaultMessage: "Advanced Tools",
    id: "audience.segments.segment.adaptive.form.advancedTools",
  },
  advertiser: {
    defaultMessage: "Advertiser*",
    id: "audience.pixels.event.advertiser",
  },
  advertiserId: {
    defaultMessage: "Advertiser Id",
    id: "audience.pixels.list.summary.advertiserId",
  },
  advertiserName: {
    defaultMessage: "Advertiser Name",
    id: "audience.pixels.list.summary.advertiserName",
  },
  agency: {
    defaultMessage: "Agency*",
    id: "audience.pixels.data.agency",
  },
  agencyConflictError: {
    defaultMessage:
      "Behaviors in a segment cannot belong to advertisers from multiple agencies",
    id: "audience.segments.standard.agencyConflictError",
  },
  agencyId: {
    defaultMessage: "Agency Id",
    id: "audience.pixels.list.summary.agencyId",
  },
  agencyName: {
    defaultMessage: "Agency Name",
    id: "audience.pixels.list.summary.agencyName",
  },
  allImpressions: {
    defaultMessage: "All Impressions",
    id: "audience.segments.adaptive.sidepanel.allImpressions",
  },
  AND: {
    defaultMessage: "AND",
    id: "audience.segmentGroups.form.segmentOperator.and",
  },
  apply: {
    defaultMessage: "Apply",
    id: "audience.segments.apply",
  },
  assignmentsLabel: {
    defaultMessage: "Select {type} Segments to add to the group:",
    id: "audience.segmentGroups.form.assignmentsLabel",
    parameterized: true,
  },
  assignmentsTitle: {
    defaultMessage: "Assignments",
    id: "audience.segmentGroups.form.assignmentsTitle",
  },
  attachedStrategyWarning: {
    defaultMessage:
      "Setting this group to Inactive may impact delivery in any strategies that use it. Review related strategies before saving.",
    id: "audience.segmentGroups.form.attachedStrategyWarning",
  },
  attachedStrategyWarningBulkActivate: {
    defaultMessage:
      "Activating these groups may impact delivery in any strategies that use them. Review related strategies before continuing.",
    id: "audience.segmentGroups.bulk.attachedStrategyWarningActivate",
  },
  attachedStrategyWarningBulkDeactivate: {
    defaultMessage:
      "Deactivating these groups may impact delivery in any strategies that use them. Review related strategies before continuing.",
    id: "audience.segmentGroups.bulk.attachedStrategyWarningDeactivate",
  },

  attributes: {
    defaultMessage: "Attributes",
    id: "audience.segments.standard.attributes",
  },
  attrName: {
    defaultMessage: "Attribute Name",
    id: "audience.pixels.event.attrName",
  },
  attrsNotSaved: {
    defaultMessage: "Advertiser Attributes could not be saved",
    id: "audience.pixels.event.attrsNotSaved",
  },
  attrsSaved: {
    defaultMessage: "Advertiser Attributes saved successfully",
    id: "audience.pixels.event.attrsSaved",
  },
  audience: {
    defaultMessage: "Audience",
    id: "audience.segmentGroups.list.type.audience",
  },
  audiencesHeader: {
    defaultMessage: "Audiences",
    id: "audience.header",
  },
  behaviorError: {
    defaultMessage: "Please add at least one behavior",
    id: "audience.segments.standard.behaviorError",
  },
  behaviorName: {
    defaultMessage: "Behavior Name",
    id: "audience.segments.standard.behaviorName",
  },
  billing: {
    defaultMessage: "Billing",
    id: "audience.pixels.data.billing",
  },
  buildExpression: {
    defaultMessage: "Build Expression*",
    id: "audience.segments.segment.form.fields.buildExpression",
  },
  buildExpressionInfo: {
    defaultMessage:
      'After a Standard Segment is saved, it cannot be edited. If you change the expression of a Standard Segment, a new Standard Segment will be saved.\n\nClick "Save As" to name the new segment.',
    id: "audience.segments.segment.form.fields.buildExpression.tooltip",
  },
  campaignId: {
    defaultMessage: "Campaign ID",
    id: "audience.segments.adaptive.sidepanel.campaignId",
  },
  campaignName: {
    defaultMessage: "Campaign Name",
    id: "audience.segments.adaptive.sidepanel.campaignName",
  },
  campaigns: {
    defaultMessage: "Campaigns",
    id: "audience.segments.adaptive.sidepanel.campaigns",
  },
  campaignStatus: {
    defaultMessage: "Campaign Status",
    id: "audience.segments.adaptive.sidepanel.campaignStatus",
  },
  cancel: {
    defaultMessage: "Cancel",
    id: "audience.pixels.list.emailCode.cancel",
  },
  changedBy: {
    defaultMessage: "Changed By",
    id: "audience.pixels.list.changelog.changedBy",
  },
  changelog: {
    defaultMessage: "View Changelog",
    id: "audience.pixels.list.actions.changelog",
  },
  changeMade: {
    defaultMessage: "Change Made",
    id: "audience.pixels.list.changelog.changeMade",
  },
  click: {
    defaultMessage: "Click",
    id: "audience.segments.adaptive.sidepanel.click",
  },
  contextual: {
    defaultMessage: "Contextual",
    id: "audience.segmentGroups.list.type.contextual",
  },
  continue: {
    defaultMessage: "Continue",
    id: "audience.segment.groups.continue",
  },
  copyPixelTag: {
    defaultMessage: "Copy Pixel Tag",
    id: "audience.pixels.list.actions.copyPixelTag",
  },
  created: {
    defaultMessage: "Created",
    id: "audience.changelog.created",
  },
  createdOn: {
    defaultMessage: "Created On",
    id: "audience.pixels.list.summary.createdOn",
  },
  creationDate: {
    defaultMessage: "Creation Date:",
    id: "audience.pixels.list.changelog.creationDate",
  },
  creator: {
    defaultMessage: "Creator",
    id: "audience.segments.list.creator",
  },
  currency: {
    defaultMessage: "Currency",
    id: "audience.pixels.event.currency",
  },
  customAttr: {
    defaultMessage: "Custom Attributes",
    id: "audience.pixels.event.customAttr",
  },
  data: {
    defaultMessage: "Data",
    id: "audience.pixels.list.btn.data",
  },
  dataAttrMapping: {
    defaultMessage: "Data Attribute Mapping",
    id: "audience.pixels.event.dataAttrMapping",
  },
  dataKey: {
    defaultMessage: "Data Key",
    id: "audience.pixels.event.dataKey",
  },
  dataPixelNotSaved: {
    defaultMessage: "Data Pixel could not be saved",
    id: "audience.pixels.data.dataPixelNotSaved",
  },
  dataPixelSaved: {
    defaultMessage: "Data Pixel saved successfully",
    id: "audience.pixels.event.dataPixelSaved",
  },
  dataProvider: {
    defaultMessage: "Data Provider*",
    id: "audience.pixels.data.dataProvider",
  },
  dataProviderSelectedNextSteps: {
    defaultMessage:
      "Next Step: Please generate code for this Data Pixel and implement with your data partner.",
    id: "audience.pixels.data.dataProviderSelectedNextSteps",
  },
  dataProviderSelectedNote: {
    defaultMessage:
      'Note: By selecting "Client pays MediaMath", the Client will pay MediaMath for Data Pixel costs and MediaMath will relay payment to the Data Provider. Alternatively, selecting a Data Provider labeled "Client pays vendor directly" means the Client assumes responsibility to pay the Data Provider directly and will not be billed by MediaMath.',
    id: "audience.pixels.data.dataProviderSelectedNote",
  },
  dataType: {
    defaultMessage: "Data Type",
    id: "audience.pixels.event.dataType",
  },
  date: {
    defaultMessage: "Date",
    id: "audience.pixels.list.changelog.date",
  },
  dateCreated: {
    defaultMessage: "Date Created",
    id: "audience.segments.list.dateCreated",
  },
  deactivate: {
    defaultMessage: "Deactivate",
    id: "audience.pixels.list.actions.deactivate",
  },
  details: {
    defaultMessage: "Details",
    id: "audience.pixels.list.summary.details",
  },
  duplicate: {
    defaultMessage: "Duplicate",
    id: "audience.segments.list.contextMenu.duplicate",
  },
  dynamic: {
    defaultMessage: "Dynamic",
    id: "audience.pixels.event.dynamic",
  },
  edit: {
    defaultMessage: "Edit",
    id: "audience.pixels.list.actions.edit",
  },
  editBehavior: {
    defaultMessage: "Edit Behavior",
    id: "audience.segments.editBehavior",
  },
  editEventPixel: {
    defaultMessage: "Edit Event Pixel",
    id: "audience.pixels.event.editEventPixel",
  },
  editPixel: {
    defaultMessage: "Edit Pixel",
    id: "audience.pixels.list.editPixel",
  },
  editSegment: {
    defaultMessage: "Edit Segment",
    id: "audience.segments.list.editSegment",
  },
  editSegmentGroup: {
    defaultMessage: "Edit Segment Group",
    id: "audience.segmentGroups.list.editSegmentGroup",
  },
  editStrategy: {
    defaultMessage: "Edit Strategy",
    id: "audience.strategyAssignment.columns.editStrategy",
  },
  eligible: {
    defaultMessage: "Eligible",
    id: "audience.pixels.list.summary.eligible",
  },
  emailPixelCode: {
    defaultMessage: "Email Pixel Code",
    id: "audience.pixels.list.actions.emailPixelCode",
  },
  emptyMessage: {
    defaultMessage: "No results found.",
    id: "audience.pixels.list.emptyMessage",
  },
  enterCommaSeparatedValues: {
    defaultMessage: "Enter comma-separated values",
    id: "audience.segments.standard.enterCommaSeparatedValues",
  },
  enterNumber: {
    defaultMessage: "Enter number",
    id: "audience.segments.standard.enterNumber",
  },
  event: {
    defaultMessage: "Event",
    id: "audience.pixels.event.event",
  },
  eventAttribute: {
    defaultMessage: "Event Attribute",
    id: "audience.segments.behavior.eventAttribute",
  },
  eventBtn: {
    defaultMessage: "Event",
    id: "audience.pixels.list.btn.eventBtn",
  },
  eventPixelNotSaved: {
    defaultMessage: "Event Pixel could not be saved",
    id: "audience.pixels.event.eventPixelNotSaved",
  },
  eventPixels: {
    defaultMessage: "Event Pixels",
    id: "audience.segments.adaptive.sidepanel.eventPixels",
  },
  eventPixelSaved: {
    defaultMessage: "Event Pixel saved successfully",
    id: "audience.pixels.event.eventPixelSaved",
  },
  eventUrlError: {
    defaultMessage: "Please enter a valid URL",
    id: "audience.pixels.event.eventUrlError",
  },
  eventUrls: {
    defaultMessage: "Event URLs",
    id: "audience.pixels.list.summary.eventUrls",
  },
  eventUrlsOpt: {
    defaultMessage: "Event URLs (optional)",
    id: "audience.pixels.event.eventUrlsOpt",
  },
  exportHistory: {
    defaultMessage: "EXPORT HISTORY",
    id: "audience.pixels.list.actions.exportHistory",
  },
  exportPixelLoadHistory: {
    defaultMessage: "Export Pixel Load History",
    id: "audience.pixels.list.actions.exportPixelLoadHistory",
  },
  exportPixelLoadHistoryError: {
    defaultMessage: "Pixel Load History could not be exported.",
    id: "audience.pixels.list.exportPixelLoadHistoryError",
  },
  exportPixelTag: {
    defaultMessage: "Export Pixel Tag",
    id: "audience.pixels.list.actions.exportPixelTag",
  },
  exportTableData: {
    defaultMessage: "Export Table Data",
    id: "audience.pixels.list.actions.exportTableData",
  },
  expression: {
    defaultMessage: "Expression",
    id: "audience.segments.standard.expression",
  },
  externalIdentifier: {
    defaultMessage: "External Identifier",
    id: "audience.pixels.list.summary.externalIdentifier",
  },
  fileName: {
    defaultMessage: "audience-pixel-data",
    id: "aaudience.pixels.list.actions.exportTableData.fileName",
  },
  fixed: {
    defaultMessage: "Fixed",
    id: "audience.pixels.event.fixed",
  },
  hideExpression: {
    defaultMessage: "Hide Expression",
    id: "audience.segments.segment.form.hideExpression",
  },
  iframeMathTag: {
    defaultMessage: "iFrame MathTag Container",
    id: "audience.pixels.event.tag.iframe",
  },
  imgMathTag: {
    defaultMessage: "Image MathTag",
    id: "audience.pixels.event.tag.img",
  },
  imgMathTagDart: {
    defaultMessage: "Image MathTag for CM360 Floodlight",
    id: "audience.pixels.event.tag.imgDart",
  },
  implementationMethod: {
    defaultMessage: "Implementation Method",
    id: "audience.pixels.event.implementationMethod",
  },
  implementationMethodTitle: {
    defaultMessage: "Implementation Method",
    id: "audience.pixels.data.implementationMethodTitle",
  },
  impression: {
    defaultMessage: "Impression",
    id: "audience.segments.adaptive.sidepanel.impression",
  },
  impressions: {
    defaultMessage: "Impressions",
    id: "audience.segments.adaptive.sidepanel.impressions",
  },
  inactive: {
    defaultMessage: "Inactive",
    id: "audience.status.inactive",
  },
  inactiveSegmentGroupWarning: {
    defaultMessage:
      "This segment group is inactive, applying it to Strategies will not impact delivery.",
    id: "audience.segmentGroups.form.inactiveSegmentGroupWarning",
  },
  jsMathTag: {
    defaultMessage:
      "JavaScript MathTag Container (Recommended for optimal performance)",
    id: "audience.pixels.event.tag.js",
  },
  keywords: {
    defaultMessage: "Keywords",
    id: "audience.pixels.list.summary.keywords",
  },
  knowledgeBase: {
    defaultMessage: "See the MediaMath Knowledge Base for more information.",
    id: "audience.pixels.event.knowledgeBase",
  },
  listOfPixels: {
    defaultMessage: "List of Pixels",
    id: "audience.pixels.list.emailCode.listOfPixels",
  },
  loading: {
    defaultMessage: "Loading...",
    id: "audience.pixels.event.loading",
  },
  loadingEventAttributes: {
    defaultMessage: "Loading Event Attributes...",
    id: "audience.segments.standard.loadingEventAttributes",
  },
  macrosNote: {
    defaultMessage:
      "You may insert macros as needed. Available macros are: [RANDOM_NUMBER].",
    id: "audience.pixels.event.macrosNote",
  },
  message: {
    defaultMessage: "Message (optional):",
    id: "audience.pixels.list.emailCode.message",
  },
  missingSegmentGroupHeader: {
    defaultMessage: "Segment Group List action is missing/incorrect",
    id: "audience.segmentGroups.form.missingSegmentGroupHeader",
  },
  modified: {
    defaultMessage: "Modified",
    id: "audience.pixels.list.modified",
  },
  name: {
    defaultMessage: "Name*",
    id: "audience.pixels.event.name",
  },
  nameError: {
    defaultMessage: "The name must include 1-64 characters",
    id: "audience.pixels.event.nameError",
  },
  namePlaceholder: {
    defaultMessage: "e.g. Homepage, Landing Page 1, Thank You Page",
    id: "audience.pixels.event.namePlaceholder",
  },
  newAdaptiveSegment: {
    defaultMessage: "New Adaptive Segment",
    id: "audience.segments.adaptive.newAdaptiveSegment",
  },
  // Form messages
  newAudienceSegmentGroup: {
    defaultMessage: "New Audience Segment Group",
    id: "audience.segmentGroups.form.newAudienceSegmentGroup",
  },
  newContextualSegmentGroup: {
    defaultMessage: "New Contextual Segment Group",
    id: "audience.segmentGroups.form.newContextualSegmentGroup",
  },
  newDataPixel: {
    defaultMessage: "New Data Pixel",
    id: "audience.pixels.data.newDataPixel",
  },
  newEventPixel: {
    defaultMessage: "New Event Pixel",
    id: "audience.pixels.event.newEventPixel",
  },
  newPixelBtn: {
    defaultMessage: "NEW PIXEL",
    id: "audience.pixels.list.btn.newPixelBtn",
  },
  newSegmentAudienceGroup: {
    defaultMessage: "Audience Group",
    id: "audience.segmentGroups.list.newSegmentAudienceGroup",
  },
  newSegmentBtn: {
    defaultMessage: "NEW SEGMENT",
    id: "audience.pixels.list.btn.newSegmentBtn",
  },
  newSegmentContextualGroup: {
    defaultMessage: "Contextual Group",
    id: "audience.segmentGroups.list.newSegmentContextualGroup",
  },
  newSegmentGroupsBtn: {
    defaultMessage: "ADD GROUPS",
    id: "audience.segmentGroups.list.newSegmentGroupsBtn",
  },
  newStandardSegment: {
    defaultMessage: "New Standard Segment",
    id: "audience.segments.standard.newStandardSegment",
  },
  newValue: {
    defaultMessage: "New Value",
    id: "audience.pixels.list.changelog.newValue",
  },
  no: {
    defaultMessage: "No",
    id: "audience.pixels.list.summary.no",
  },
  noEventAttr: {
    defaultMessage: "No event attributes available",
    id: "audience.segments.standard.sidepanel.noEventAttr",
  },
  noSelectedBehaviors: {
    defaultMessage: "No behaviors selected",
    id: "audience.segments.standard.sidepanel.noSelectedBehaviors",
  },
  numeric: {
    defaultMessage: "Numeric",
    id: "audience.pixels.event.numeric",
  },
  numSelected: {
    defaultMessage: "{numSelected} Selected",
    id: "audience.pixels.list.numSelected",
    parameterized: true,
  },
  oldValue: {
    defaultMessage: "Old Value",
    id: "audience.pixels.list.changelog.oldValue",
  },
  operator: {
    defaultMessage: "Operator",
    id: "audience.segments.behavior.operator",
  },
  OR: {
    defaultMessage: "OR",
    id: "audience.segmentGroups.form.segmentOperator.or",
  },
  overrideAdvAttr: {
    defaultMessage: "Override Advertiser Level Custom Attributes",
    id: "audience.pixels.event.overrideAdvAttr",
  },
  pageErrors: {
    defaultMessage: "There are errors on the page",
    id: "audience.pixels.event.pageErrors",
  },
  pixelCodes: {
    defaultMessage: "Pixel Codes",
    id: "audience.pixels.list.summary.pixelCodes",
  },
  pixelID: {
    defaultMessage: "Pixel ID",
    id: "audience.pixels.list.pixelID",
  },
  pixelLoads: {
    defaultMessage: "Pixel Loads",
    id: "audience.pixels.list.pixelLoads",
  },
  pixelName: {
    defaultMessage: "Pixel Name",
    id: "audience.pixels.list.pixelName",
  },
  pixels: {
    defaultMessage: "Pixels",
    id: "audience.pixels",
  },
  pixelStatus: {
    defaultMessage: "Pixel Status",
    id: "audience.pixels.list.pixelStatus",
  },
  pixelTag: {
    defaultMessage: "Pixel Tag",
    id: "audience.pixels.list.pixelTag",
  },
  pixelType: {
    defaultMessage: "Pixel Type",
    id: "audience.pixels.list.pixelType",
  },
  pixelTypeTitle: {
    defaultMessage: "Pixel Type",
    id: "audience.pixels.event.pixelTypeTitle",
  },
  pricing: {
    defaultMessage: "Pricing",
    id: "audience.pixels.list.summary.pricing",
  },
  pricingCPM: {
    defaultMessage: "CPM",
    id: "audience.data.cpm",
  },
  pricingCPMError: {
    defaultMessage: "Please enter a valid CPM",
    id: "audience.pixels.data.pricingCPMError",
  },
  pricingMediaCost: {
    defaultMessage: "% of Media Cost",
    id: "audience.pixels.data.mediaCost",
  },
  pricingMediaCostError: {
    defaultMessage: "Please enter a valid % of Media Cost",
    id: "audience.pixels.data.pricingMediaCostError",
  },
  pricingTitle: {
    defaultMessage: "Pricing*",
    id: "audience.pixels.data.pricingTitle",
  },
  providerAdvertiserName: {
    defaultMessage: "Provider/Advertiser Name",
    id: "audience.pixels.list.providerAdvertiserName",
  },
  providerId: {
    defaultMessage: "Provider ID",
    id: "audience.pixels.list.summary.providerId",
  },
  retrieve90days: {
    defaultMessage: "You can retrieve up to 90 days of data.",
    id: "audience.pixels.list.exportHistory.retrieve90days",
  },
  revenue: {
    defaultMessage: "Revenue",
    id: "audience.pixels.event.revenue",
  },
  revenueAttr: {
    defaultMessage: "Revenue Attribution Pair",
    id: "audience.pixels.event.revenueAttr",
  },
  revenueTtip: {
    defaultMessage:
      "Set the Revenue and Currency attribution values for future pixel fires. These settings will automatically enable reporting for campaigns using these merit event pixels.",
    id: "audience.pixels.event.revenueTtip",
  },
  rmxConversionMinutes: {
    defaultMessage: "RMX Conversion Minutes",
    id: "audience.pixels.list.summary.rmxConversionMinutes",
  },
  rmxConversionType: {
    defaultMessage: "RMX Conversion Type",
    id: "audience.pixels.list.summary.rmxConversionType",
  },
  rmxFriendly: {
    defaultMessage: "RMX Friendly",
    id: "audience.pixels.list.summary.rmxFriendly",
  },
  rmxMerit: {
    defaultMessage: "RMX Merit",
    id: "audience.pixels.list.summary.rmxMerit",
  },
  save: {
    defaultMessage: "SAVE",
    id: "audience.pixels.event.save",
  },
  saveAs: {
    defaultMessage: "SAVE AS",
    id: "audience.pixels.event.saveAs",
  },
  saveAsClose: {
    defaultMessage: "SAVE AS AND CLOSE",
    id: "audience.pixels.event.saveAsClose",
  },
  saveClose: {
    defaultMessage: "SAVE AND CLOSE",
    id: "audience.pixels.event.saveClose",
  },
  segmentCodeColumn: {
    defaultMessage: "Code",
    id: "audience.segmentGroups.form.segmentCodeColumn",
  },
  segmentExport: {
    defaultMessage: "Segment Export",
    id: "audience.segments.list.segmentExportBtn",
  },
  segmentGroupCurrency: {
    defaultMessage: "Currency:",
    id: "audience.segmentGroups.form.segmentGroupCurrency",
  },
  segmentGroupCurrencyTooltip: {
    defaultMessage:
      "Changing the currency updates how costs are displayed. This setting is not saved and will reset when the page reloads. The actual currency used will be defined by the Campaign and Strategy this group is attached to.",
    id: "audience.segmentGroups.form.segmentGroupCurrencyTooltip",
  },
  segmentGroupEdit: {
    defaultMessage: "EDIT",
    id: "audience.segmentGroups.form.segmentGroupEdit",
  },
  segmentGroupEstimatedCPMRange: {
    defaultMessage: "Estimated Group CPM Range: {minCost} - {maxCost}",
    id: "audience.segmentGroups.form.estimated.cpm.range",
    parameterized: true,
  },
  segmentGroupID: {
    defaultMessage: "Group ID",
    id: "audience.segmentGroups.list.groupId",
  },
  segmentGroupMaxCost: {
    defaultMessage: "Group maximum cost: {maxCost}",
    id: "audience.segmentGroups.form.segmentGroupMaxCost",
    parameterized: true,
  },
  segmentGroupMaxCostTooltip: {
    defaultMessage:
      "The maximum CPM cost for the Group. The Group will not be applied to any {segmentType} Segments with a CPM cost higher than this value.",
    id: "audience.segmentGroups.form.segmentGroupMaxCostTooltip",
    parameterized: true,
  },
  segmentGroupModified: {
    defaultMessage: "Modified",
    id: "audience.segmentGroups.list.modified",
  },
  segmentGroupName: {
    defaultMessage: "Group Name",
    id: "audience.segmentGroups.list.groupName",
  },
  segmentGroupNotSaved: {
    defaultMessage: "{type} Group could not be saved",
    id: "audience.segmentGroups.form.segmentGroupNotSaved",
    parameterized: true,
  },
  segmentGroupSaved: {
    defaultMessage: "{type} Group saved successfully",
    id: "audience.segmentGroups.form.dataPixelSaved",
    parameterized: true,
  },
  segmentGroupSegments: {
    defaultMessage: "Segments",
    id: "audience.segmentGroups.list.segments",
  },
  segmentGroupsTabName: {
    defaultMessage: "Audience/Contextual Groups",
    id: "audience.segmentGroups.segmentGroupsTabName",
  },
  segmentGroupStatus: {
    defaultMessage: "Group Status",
    id: "audience.segmentGroups.list.groupStatus",
  },
  segmentGroupStrategiesTargeted: {
    defaultMessage: "Strategies Targeted",
    id: "audience.segmentGroups.list.strategiesTargeted",
  },
  segmentGroupType: {
    defaultMessage: "Group Type",
    id: "audience.segmentGroups.list.groupType",
  },
  segmentId: {
    defaultMessage: "Segment ID",
    id: "audience.segments.list.segmentId",
  },
  segmentName: {
    defaultMessage: "Segment Name",
    id: "audience.segments.list.segmentName",
  },
  segmentNameColumn: {
    defaultMessage: "Segment",
    id: "audience.segmentGroups.form.segmentColumn",
  },
  segmentOperatorTitle: {
    defaultMessage: "Group Operator:",
    id: "audience.segmentGroups.form.segmentOperatorTitle",
  },
  segments: {
    defaultMessage: "Segments",
    id: "audience.segments",
  },
  segmentSelectionDrawerTitle: {
    defaultMessage: "Selected Segments",
    id: "audience.segmentGroups.form.segmentSelectionDrawerTitle",
  },
  segmentSelectionSidePanelHeader: {
    defaultMessage: "Select Segments",
    id: "audience.segmentGroups.form.segmentSelectionSidePanelHeader",
  },
  segmentSize: {
    defaultMessage: "Segment Size",
    id: "audience.segments.adaptive.segmentSize",
  },
  segmentSizeUpdated: {
    defaultMessage: "Segment Size Updated",
    id: "audience.segments.adaptive.segmentSizeUpdated",
  },
  segmentSizeColumn: {
    defaultMessage: "Total Size",
    id: "audience.segmentGroups.form.segmentSizeColumn",
  },
  segmentType: {
    defaultMessage: "Segment Type",
    id: "audience.segments.list.segmentType",
  },
  segmentTypeColumn: {
    defaultMessage: "Type",
    id: "audience.segmentGroups.form.segmentTypeColumn",
  },
  select: {
    defaultMessage: "Select",
    id: "audience.pixels.event.select",
  },
  selectAdvertiser: {
    defaultMessage: "Select an Advertiser",
    id: "audience.pixels.event.selectAdvertiser",
  },
  selectAdvertiserError: {
    defaultMessage: "Please select an advertiser",
    id: "audience.pixels.event.selectAdvertiserError",
  },
  selectAgency: {
    defaultMessage: "Select an Agency",
    id: "audience.pixels.data.selectAgency",
  },
  selectAgencyError: {
    defaultMessage: "Please select an agency",
    id: "audience.pixels.data.selectAgencyError",
  },
  selectCurrecyError: {
    defaultMessage: "Please select a currency",
    id: "audience.pixels.event.selectCurrecyError",
  },
  selectCurrency: {
    defaultMessage: "Select Currency",
    id: "audience.pixels.event.selectCurrency",
  },
  selectDataProvider: {
    defaultMessage: "Select a Data Provider",
    id: "audience.pixels.data.selectDataProvider",
  },
  selectDataProviderError: {
    defaultMessage: "Please select a data provider",
    id: "audience.pixels.data.selectDataProviderError",
  },
  selectDataType: {
    defaultMessage: "Please select a Data Type",
    id: "audience.pixels.event.selectDataType",
  },
  selectDate: {
    defaultMessage: "Select a date or date range",
    id: "audience.segments.standard.selectDate",
  },
  selectedBehaviors: {
    defaultMessage: "Selected Behaviors",
    id: "audience.segments.selectedBehaviors",
  },
  selectEventAttr: {
    defaultMessage: "Select event attribute",
    id: "audience.segments.standard.selectEventAttr",
  },
  selectOperator: {
    defaultMessage: "Select operator",
    id: "audience.segments.standard.selectOperator",
  },
  selectParam: {
    defaultMessage: "Select Parameter",
    id: "audience.pixels.event.selectParam",
  },
  selectParamError: {
    defaultMessage: "Please select a parameter",
    id: "audience.pixels.event.selectParamError",
  },
  selectParameter: {
    defaultMessage: "Select Parameter",
    id: "audience.pixels.event.selectParameter",
  },
  selectParameterError: {
    defaultMessage: "Please select a parameter",
    id: "audience.pixels.event.selectParameterError",
  },
  selectSegmentAssignmentError: {
    defaultMessage: "Please select at least one segment assignment",
    id: "audience.segmentGroups.form.selectSegmentAssignmentError",
  },
  selectStandardAttr: {
    defaultMessage: "Select Standard Attributes",
    id: "audience.pixels.event.selectStandardAttr",
  },
  sendEmail: {
    defaultMessage: "SEND EMAIL",
    id: "audience.pixels.list.emailCode.sendEmail",
  },
  size: {
    defaultMessage: "Size",
    id: "audience.segments.list.size",
  },
  sizeTtip: {
    defaultMessage:
      "Number of unique users in the segment. Size calculation depends on the selected Segment Type.",
    id: "audience.segments.list.sizeTtip",
  },
  sizeUpdated: {
    defaultMessage: "Size Updated",
    id: "audience.segments.list.sizeUpdated",
  },
  sizeUpdatedTtip: {
    defaultMessage:
      "The last time the segment size was calculated. Size updates stop when the segment is not in active use.",
    id: "audience.segments.list.sizeUpdatedTtip",
  },
  sizeWarning: {
    defaultMessage: "Size updates stop when the segment is not in active use.",
    id: "audience.segments.form.sizeWarning",
  },
  showExpression: {
    defaultMessage: "Show Expression",
    id: "audience.segments.segment.form.showExpression",
  },
  standard: {
    defaultMessage: "Standard",
    id: "audience.segments.list.column.standard",
  },
  standardAttr: {
    defaultMessage: "Standard Attributes",
    id: "audience.pixels.event.standardAttr",
  },
  standardSegment: {
    defaultMessage: "Standard Segment",
    id: "audience.segments.list.btn.standardSegment",
  },
  standardSegmentFailed: {
    defaultMessage: "Standard Segment could not be saved",
    id: "audience.segments.segment.form.standardSegmentFailed",
  },
  standardSegmentName: {
    defaultMessage: "Standard Segment Name",
    id: "audience.segments.segment.form.standardSegmentName",
  },
  standardSegmentSaved: {
    defaultMessage: "Standard Segment saved successfully",
    id: "audience.segments.segment.form.standardSegmentSaved",
  },
  status: {
    defaultMessage: "Status",
    id: "audience.pixels.event.status",
  },
  strategiesLabel: {
    defaultMessage: "List of Strategies the Group is applied to:",
    id: "audience.segmentGroups.form.strategiesLabel",
  },
  strategiesTitle: {
    defaultMessage: "Strategies",
    id: "audience.segmentGroups.form.strategiesTitle",
  },
  strategyAssignmentPermissionWarning: {
    defaultMessage:
      "Strategy visibility may be limited based on your permissions.",
    id: "audience.segmentGroups.form.strategyAssignmentPermissionWarning",
  },
  strategyId: {
    defaultMessage: "Strategy ID",
    id: "audience.segmentGroups.form.strategyIdColumn",
  },
  strategyName: {
    defaultMessage: "Strategy Name",
    id: "audience.segmentGroups.form.strategyNameColumn",
  },
  strategyStatus: {
    defaultMessage: "Strategy Status",
    id: "audience.segments.adaptive.sidepanel.strategyStatus",
  },
  string: {
    defaultMessage: "String",
    id: "audience.pixels.event.string",
  },
  summary: {
    defaultMessage: "View Summary",
    id: "audience.pixels.list.actions.summary",
  },
  t1ClientInvoiced: {
    defaultMessage:
      "MediaMath pays data provider (Client invoiced by MediaMath)",
    id: "audience.pixels.data.t1ClientInvoiced",
  },
  t1ClientNotInvoiced: {
    defaultMessage:
      "Client pays data provider directly (Client is not invoiced by MediaMath)",
    id: "audience.pixels.data.t1ClientNotInvoiced",
  },
  tag: {
    defaultMessage: "Tag",
    id: "audience.pixels.list.summary.tag",
  },
  tagType: {
    defaultMessage: "Tag Type",
    id: "audience.pixels.list.summary.tagType",
  },
  to: {
    defaultMessage: "To:",
    id: "audience.pixels.list.emailCode.to",
  },
  toastError: {
    defaultMessage: "Error",
    id: "audience.pixels.list.toastError",
  },
  toastSuccess: {
    defaultMessage: "Success",
    id: "audience.pixels.list.toastSuccess",
  },
  toPlaceHolder: {
    defaultMessage: "Type Recipient Email(s) separated by a comma",
    id: "audience.pixels.list.emailCode.toPlaceHolder",
  },
  type: {
    defaultMessage: "Type",
    id: "audience.pixels.list.changelog.type",
  },
  typeMessage: {
    defaultMessage: "Type Message",
    id: "audience.pixels.list.emailCode.typeMessage",
  },
  typeToSearch: {
    defaultMessage: "Type to search",
    id: "audience.segments.list.filter.advertiser.placeholder",
  },
  uniquePixelLoads: {
    defaultMessage: "Unique Pixel Loads",
    id: "audience.pixels.list.uniquePixelLoads",
  },
  unsavedChanges: {
    defaultMessage: "There are unsaved changes on the page",
    id: "audience.pixels.event.unsavedChanges",
  },
  updatedOn: {
    defaultMessage: "Updated On",
    id: "audience.pixels.list.summary.updatedOn",
  },
  updatePixelSuccessMessage: {
    defaultMessage: "Pixel(s) saved successfully",
    id: "audience.pixels.list.updatePixelSuccessMessage",
  },
  updateSegmentGroupSuccessMessage: {
    defaultMessage: "Segment Group(s) saved successfully",
    id: "audience.segmentGroups.list.updateSegmentGroupSuccessMessage",
  },
  value: {
    defaultMessage: "Value",
    id: "audience.segments.behavior.value",
  },
  view: {
    defaultMessage: "View",
    id: "audience.segments.list.contextMenu.view",
  },
  viewPixelLoad: {
    defaultMessage: "View pixel load counts for the past number of days:",
    id: "audience.pixels.list.exportHistory.viewPixelLoad",
  },
  warning: {
    defaultMessage: "Warning",
    id: "audience.segment.groups.warning",
  },
  yes: {
    defaultMessage: "Yes",
    id: "audience.pixels.list.summary.yes",
  },
});

export default AudienceMessages;
